import * as React from 'react';

interface Props {
    value: string;
}
export function HtmlString(props: Props) {
    return (
        <div dangerouslySetInnerHTML={{ __html: props.value }} />
    );
}